// extracted by mini-css-extract-plugin
export default {"zoomModal":"n1-z"};